export default __webpack_public_path__ + "static/media/icon-minus.a1f316e7.svg";